export const SIGNATURE_PREFIX = '__signature__';

export const SOFTONE_FILES = 1;
export const SOFTONE_DATABASE = 2;
